import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import {
  InsuranceValidationPayload,
  InsuranceValidationResponse,
} from './silobag-insurance-validation.types';
import { transformIntoQueryParamString } from '@old/utils/service';

export async function silobagInsuranceValidationService({ query: rawQuery }: InsuranceValidationPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.get<InsuranceValidationResponse>(ENDPOINT.INSURANCE_VALIDATION, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
